<template>
    <span
      style="display: flex; width: 100%; height: 100%; align-items: center; justify-content: center; user-select: none"
      >
        <training-icon
          :school_state="value.school"
          :training_state="value.training"
          :dark="dark">
        </training-icon>
    </span>
</template>

<script>

import TrainingIcon from './TrainingIcon.vue'

export default {
    name: 'TrainingCell',
    props: {
        dark: Boolean,
        value: {
            type: Object,
            default: () => ({
                school: 'no',
                training: 'no'
            })
        }
    },
    data: function () {
        return {
        }
    },
    methods: {
    },
    mounted: function () {
    },
    components: {
        TrainingIcon
    }
}

</script>
